import { Share2, Facebook, MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const copy = async (url, msg) => {
  try { await navigator.clipboard.writeText(url); toast.success(msg); } catch (e) { toast.error("Could not copy the link"); }
};

export const ShareBar = ({ title, url, testPrefix = "share" }) => {
  const native = async () => {
    if (navigator.share) {
      try { await navigator.share({ title, url }); } catch (e) { /* cancelled */ }
      return;
    }
    copy(url, "Link copied, paste it anywhere to share");
  };
  const messenger = () => {
    if (isMobile()) window.location.href = `fb-messenger://share/?link=${encodeURIComponent(url)}`;
    else copy(url, "Link copied, paste it in your Messenger chat");
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid={`${testPrefix}-bar`}>
      <Button asChild variant="outline" size="sm" className="rounded-full" data-testid={`${testPrefix}-facebook`}>
        <a href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noreferrer"><Facebook className="mr-1 h-4 w-4" /> Facebook</a>
      </Button>
      <Button variant="outline" size="sm" className="rounded-full" onClick={messenger} data-testid={`${testPrefix}-messenger`}><MessageCircle className="mr-1 h-4 w-4" /> Messenger</Button>
      <Button size="sm" className="rounded-full bg-[#0A3A6B] hover:bg-[#1D64B4]" onClick={native} data-testid={`${testPrefix}-native`}><Share2 className="mr-1 h-4 w-4" /> Share</Button>
    </div>
  );
};
